import PropTypes from 'prop-types';
import PageHeader from '../PageHeader';
import CycleCreateContent from './CycleCreateContent';
import CycleCreateWarnings from './CycleCreateWarnings';

function CycleCreate(props) {
    const { header, content, controls, warnings, getValidationData } = props.configuration;
    const modelSelector = props.modelSelector || (state => state[props.modelProperty].model);

    return (
        <div>
            <section className="page_static">
                <PageHeader title={header.title} documentation={header.documentation} />
                <CycleCreateWarnings warnings={warnings} modelSelector={modelSelector} />
            </section>
            <CycleCreateContent
                content={content}
                controls={controls}
                modelSelector={modelSelector}
                getValidationData={getValidationData}
            />
        </div>
    );
}

CycleCreate.propTypes = {
    configuration: PropTypes.object,
    header: PropTypes.object,
    controls: PropTypes.object,
};

export default CycleCreate;
